import { forwardRef, Fragment, memo, useState } from 'react';
import cx from 'classnames';
import { useRefArray } from '../../../hooks/useRefArray';
import { useResizeObserverRef } from '../../../hooks/useResizeObserver';
import { setRef } from '../../../util/ref-util';
import { postfixTestId } from '../../../util/testId';
import { Label } from '../../Label';
import cn from './SliderTickLabels.css.json';
import './SliderTickLabels.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const SliderTickLabels = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((props, ref) => {
  const [firstLabelWidth, setFirstLabelWidth] = useState(0);
  const {
    refs: labelRefs,
    createSetRef: createLabelRef
  } = useRefArray();
  const [setLabelsWrapperRef, getLabelsWrapperRef] = useResizeObserverRef(() => {
    const secondLabel = labelRefs[1];
    const wrapper = getLabelsWrapperRef();
    if (labelRefs.length === 1 && wrapper) {
      setFirstLabelWidth(wrapper.getBoundingClientRect().width / 2);
    }
    if (secondLabel) {
      setFirstLabelWidth(secondLabel.getBoundingClientRect().width / 2);
    }
  });
  const isHorizontal = props.orientation === 'horizontal';
  const labels = [];
  if (props.ticks) {
    let total = 0;
    for (let i = 0, l = props.ticks.length; i < l; ++i) {
      const value = props.ticks[i];
      const lastValue = props.ticks[i - 1];
      let valueText;
      if (props.tickLabels?.length) {
        valueText = props.tickLabels[i];
      } else {
        valueText = props.format.format(value);
      }
      const pos = props.scale.position(value);
      let itemLength = pos;
      if (lastValue !== undefined) {
        itemLength = pos - props.scale.position(lastValue);
      }
      if (i === l - 1 && value === props.scale.maxValue) {
        // NOTE: handles case when scale.minValue === scale.maxValue
        itemLength = 1 - total;
      }
      total += itemLength;
      labels.push( /*#__PURE__*/_jsx("div", {
        "data-testid": postfixTestId(props.testId, `label${i}`),
        id: props.tickIds[i],
        ref: el => createLabelRef(i)(el),
        style: {
          [props.orientation === 'vertical' ? 'height' : 'width']: `${itemLength * 100}%`
        },
        children: /*#__PURE__*/_jsx("span", {
          style: i === 0 && isHorizontal ? {
            width: `${firstLabelWidth}px`
          } : {},
          className: cx(cn.label[props.orientation], props.disabled && cn.disabled, {
            [cn.labelHorizontalFirst]: value === props.scale.minValue && i === 0 && isHorizontal
          }, {
            [cn.labelHorizontalLast]: value === props.scale.maxValue && i === l - 1 && isHorizontal
          }),
          children: /*#__PURE__*/_jsx(Label, {
            className: cn.sliderTickLabel,
            wrapText: false,
            disabled: props.disabled,
            children: valueText
          })
        })
      }, i));
    }
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": props.testId,
      className: cn.labelContainer[props.orientation],
      ref: el => {
        setRef(ref, el);
        setRef(setLabelsWrapperRef, el);
      },
      children: props.orientation === 'vertical' ? labels.reverse() : labels
    })
  });
}));
//# sourceMappingURL=SliderTickLabels.js.map